import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleWidgets } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc Dashboard defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { DashboardService } from 'services/dashboard';
 *
 * // create service instance and send/cancel request
 * const dashboardService = new DashboardService();
 * const result = await dashboardService.fetchData( '<user-id>' ); // fetch data
 * dashboardService.cancel(); // cancel an active request
 */
export class DashboardService extends HttpService {

    // make request and fetch widgets to display
    async fetchWidgets( { data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: get( CONFIG, 'endpoints.routes.dashboard', '' ),
                data,
            } );

            // extract widgets from the response
            const componentData = get( response, 'body.component', {} );
            const widgets = getVisibleWidgets( componentData );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    widgets,
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
